import { getLocal, setLocal } from '@laigu/utils/storage';
import { getMarkKey } from '@/utils';

const localKey = 'agentClue';
export const getLocalClueData = () => {
  const agentMarkData = getLocal(localKey) || {};
  let data = [];
  if (agentMarkData) {
    data = agentMarkData[getMarkKey()] || [];
  }
  return data;
};

export const setLocalClueData = convClue => {
  let data = getLocal(localKey);
  if (!data) {
    setLocal(localKey, {});
    data = getLocal(localKey);
  }
  // 限制置顶最大数量999
  if (convClue.length > 999) {
    convClue.splice(0, convClue.length - 999);
  }
  data[getMarkKey()] = convClue;

  setLocal(localKey, data);
};
